import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginComponent } from './pages/login/login.component';
import { ListfilesComponent } from './pages/listfiles/listfiles.component';
import { BillboardComponent } from './components/billboard/billboard.component';
import { LabelinputComponent } from './components/labelinput/labelinput.component';
import { FormsModule } from '@angular/forms';
import { ButtoncomponentComponent } from './components/buttoncomponent/buttoncomponent.component';
import { TablecomponentComponent } from './components/tablecomponent/tablecomponent.component';
import { IconComponent } from './components/icon/icon.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { VisualizerComponent } from './modals/visualizer/visualizer.component';
import { MatDialogModule } from '@angular/material/dialog';
import { TooglebuttonComponent } from './components/tooglebutton/tooglebutton.component';
import { VisualizererrorsComponent } from './modals/visualizererrors/visualizererrors.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    BillboardComponent,
    ListfilesComponent,
    ButtoncomponentComponent,
    IconComponent,
    SpinnerComponent,
    TablecomponentComponent,
    LabelinputComponent,
    VisualizerComponent,
    TooglebuttonComponent,
    VisualizererrorsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatDialogModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
